<template>
    <div class="live-item-box" @click="jumpToLive">
        <div class="img-box">
            <img :src="data.previewUrl" class="live-img" />
        </div>
        <div class="content-box">
            <p class="live-name">{{ data.title }}</p>
            <ul class="tag-list">
                <li v-for="tag in tags" :key="tag">{{ tag }}</li>
            </ul>
            <p class="bottom-content">
                <span>{{ formatTime(data.startTime, 'YYYY.MM.DD') }}</span>
                <span class="view-box">
                    <i class="iconfont icon-a-chakanmima-dakai1x"></i>
                    {{ data.viewUserTimes || 0 }}观看
                </span>
            </p>
        </div>
        <span :class="['status-tag', 'status-tag-' + data.liveStatus]"
            ><img class="status-tag-img" />{{ statusText }}</span
        >
    </div>
</template>

<script setup>
import { computed } from 'vue';
import { formatTime } from '@/lib/tools';
import { pageJump } from '@/global/location-transfer';

const props = defineProps({
    data: {
        type: Object,
        default: () => {},
    },
});

const tags = computed(() => {
    const str = props.data?.tagStr;
    if (!str) return [];
    const list = str.split(',');
    return list.slice(0, 3);
});

const statusText = computed(() => {
    const statusMap = {
        0: '直播中',
        1: '预告',
        2: '回放',
        3: '回放', // 数据库无3
        4: '直播中',
    };
    // 直播状态 0-直播中 1-预告 2-已结束 3-定时上架 4-已下架
    const status = props.data.liveStatus;
    // 是否开放回放 1-是 0-否
    return status === 2 && props.data.isRec !== 1 ? '已结束' : statusMap[status];
});

function jumpToLive() {
    const domain =
        {
            local: '//live2-dev.yanxiu.com',
            dev: '//live2-dev.yanxiu.com',
            qa: '//live2-qa.yanxiu.com',
            production: '//live.yanxiu.com',
        }[process.env.VUE_APP_MODE] || '//live.yanxiu.com';
    pageJump(`${domain}/lv2/program/${props.data.id}/detail`, true);
}
</script>

<style lang="scss" scoped>
.live-item-box {
    position: relative;
    font-size: 0;
    border-radius: 4px;
    overflow: hidden;
    cursor: pointer;
    &:hover {
        box-shadow: 0px 1px 12px 0px rgba(0, 0, 0, 0.15);
    }
    .status-tag {
        position: absolute;
        left: 10px;
        top: 10px;
        display: inline-block;
        padding: 0 8px;
        border-radius: 4px;
        line-height: 22px;
        color: #fff;
        font-size: 12px;
        background: #838b9b;
        &.status-tag-1 {
            background: #4387ff;
        }
        &.status-tag-0,
        &.status-tag-4 {
            background: #ff6f50;
            padding-left: 22px;
            &::before {
                content: '';
                width: 10px;
                height: 11px;
                background: url(~@/assets/img/home/live-icon.png) no-repeat 0 0;
                background-size: 100% auto;
                position: absolute;
                left: 8px;
                top: 6px;
            }
        }
    }
    .img-box {
        position: relative;
        padding: 28.9% 0;
    }
    .live-img {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
    .content-box {
        padding: 15px 14px;
        border: 1px solid #eeeeee;
        border-top: 0;
        border-radius: 0 0 4px 4px;
    }
    .live-name {
        height: 48px;
        font-family: MicrosoftYaHei;
        font-weight: bold;
        font-size: 16px;
        color: #222222;
        line-height: 24px;
        overflow: hidden;
        text-overflow: ellipsis;
        word-break: break-all;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
    }
    .tag-list {
        margin-top: 10px;
        display: flex;
        align-items: center;
        height: 26px;
        overflow: hidden;
        flex-wrap: wrap;
        > li {
            max-width: 255px;
            background: #fafafa;
            border-radius: 4px;
            border: 1px solid #e1e1e1;
            line-height: 24px;
            padding: 0 8px;
            font-size: 12px;
            color: #555555;
            margin-right: 8px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            &:last-child {
                margin-right: 0;
            }
        }
    }
    .bottom-content {
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 12px;
        color: #555555;
        line-height: 18px;
        margin-top: 10px;
        .view-box {
            display: flex;
            align-items: center;
        }
        .icon-a-chakanmima-dakai1x {
            margin-right: 4px;
            color: #cccccc;
        }
    }
}
</style>
